import { render, staticRenderFns } from "./OFormSettingComp.vue?vue&type=template&id=f53962f2&"
import script from "./OFormSettingComp.vue?vue&type=script&lang=js&"
export * from "./OFormSettingComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports